var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-quick-links" }, [
    _c("p", { staticClass: "top-title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("tenantProjects.quickLinks")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "link-list" },
      [
        _vm._l(_vm.quickLinkList, function (item, index) {
          return [
            item.showLink()
              ? _c("li", { key: index, staticClass: "link-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link-item__title",
                      on: { click: item.onClick },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.titleText()) + "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isEngineer && item.overviewText
                    ? _c("span", { staticClass: "link-item__overview" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.overviewText()) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isTenant
      ? _c(
          "div",
          { staticClass: "regulations-links" },
          _vm._l(_vm.redirectLinksList, function (link) {
            return _c(
              "a",
              {
                key: link.key,
                staticClass: "name-hyper-link",
                attrs: { href: link.value, target: "_blank" },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("tenancy." + link.key)) + "\n    "
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }